import React from 'react';
import CountUp from 'react-countup';

const StatsCards = ({ stats, onInventoryClick, onPickedUpClick, onTotalClick }) => {
  const statItems = [
    {
      label: 'Total Scanned Packages',
      value: stats.total_packages,
      icon: 'fas fa-camera',
      gradient: 'from-indigo-500 via-purple-500 to-pink-500',
      bgPattern: 'bg-indigo-50',
      clickable: true,
      onClick: onTotalClick
    },
    {
      label: 'Active Inventory',
      value: stats.active_packages,
      icon: 'fas fa-boxes',
      gradient: 'from-orange-500 via-red-500 to-pink-500',
      bgPattern: 'bg-orange-50',
      clickable: true,
      onClick: onInventoryClick
    },
    {
      label: 'Picked Up Today',
      value: stats.picked_up_today,
      icon: 'fas fa-check-circle',
      gradient: 'from-green-500 via-teal-500 to-blue-500',
      bgPattern: 'bg-green-50',
      clickable: true,
      onClick: onPickedUpClick
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {statItems.map((item, index) => (
        <div 
          key={index}
          className={`relative ${item.bgPattern} rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 hover:scale-105 transform border border-white backdrop-blur-sm ${item.clickable ? 'cursor-pointer' : ''}`}
          style={{ animationDelay: `${index * 150}ms`, animation: 'fadeSlideUp 0.5s ease-out forwards' }}
          data-testid={`stat-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
          onClick={item.clickable ? item.onClick : undefined}
        >
          {/* Gradient overlay */}
          <div className={`absolute inset-0 bg-gradient-to-br ${item.gradient} rounded-2xl opacity-90`}></div>
          
          {/* Glass effect overlay */}
          <div className="absolute inset-0 bg-white bg-opacity-10 rounded-2xl backdrop-blur-sm"></div>
          
          {/* Content */}
          <div className="relative z-10 flex items-center justify-between text-white">
            <div>
              <p className="text-white/90 text-sm font-semibold uppercase tracking-wider mb-2">
                {item.label}
              </p>
              <p className="text-5xl font-bold leading-none">
                <CountUp
                  end={item.value || 0}
                  duration={1.5}
                  separator=","
                  preserveValue={true}
                />
              </p>
              <div className="mt-3 flex items-center">
                <div className="w-8 h-1 bg-white bg-opacity-60 rounded-full mr-2"></div>
                <span className="text-white/80 text-xs uppercase tracking-wide">Live Data</span>
              </div>
            </div>
            <div className="bg-white/20 p-4 rounded-2xl backdrop-blur-sm border border-white/30">
              <i className={`${item.icon} text-3xl`}></i>
            </div>
          </div>
          
          {/* Decorative elements */}
          <div className="absolute top-4 right-4 w-2 h-2 bg-white rounded-full opacity-60"></div>
          <div className="absolute bottom-4 left-4 w-1 h-1 bg-white rounded-full opacity-40"></div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;